module.exports = __webpack_public_path__ + "media/images/lb/983-84b691aebf9ccb052dd1684408412598.svg";